<template>
  <main role="main" id="main_app">
    <slot />
  </main>
</template>

<script>
export default {
  name: "onlybody",
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
  #main_app {
    height: 100vh;
  }
</style>